import { render, staticRenderFns } from "./DashboardBrowserStates.vue?vue&type=template&id=354e9861&"
import script from "./DashboardBrowserStates.vue?vue&type=script&lang=js&"
export * from "./DashboardBrowserStates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports